// extracted by css-extract-rspack-plugin
export default {"container":"wxNG2KobMYgwN8It","not_image":"Q18KFVk8I7HYS_Qx","delete_file":"mK2lgZddLoitbKXz","only_one_file":"Ceht9uj1O7wwakQ7","title":"jFL7IV_00W5ht816"};